import React from "react";
import {
  Datagrid,
  TextField,
  List,
  ResourceComponentProps,
  Filter,
  TextInput,
  DateField,
  ReferenceField,
} from "react-admin";

export const AlayaCareEnvironmentList = (props: ResourceComponentProps) => (
  <List
    {...props}
    bulkActionButtons={false}
    title="AlayaCare Environments"
    filters={
      <Filter {...props}>
        <TextInput label="Search by base API url" source="q" alwaysOn />
      </Filter>
    }
  >
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField
        sortable={false}
        label="Organization"
        reference="Organization"
        source="organization.id"
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source="baseApiUrl" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </Datagrid>
  </List>
);
